// extracted by mini-css-extract-plugin
export default {"custom-dropdown":"ContentTypeTemplate_custom-dropdown__3P2Bc"};